import React from 'react'
import {Route, Switch, Redirect} from "react-router-dom";
import FarmerScreen from "../screens/farmer/FarmerScreen";
import EquipmentServiceScreen from "../screens/farmer/equipment_service/EquipmentServiceScreen";
import ManageEquipment from "../screens/farmer/equipment_service/ManageEquipment";
import EquipmentScreen from "../screens/farmer/equipment_service/EquipmentScreen";
import WalletScreen from "../screens/farmer/wallet/WalletScreen";
import WalletSettingsScreen from "../screens/farmer/wallet/WalletSettingsScreen";
import CheckoutScreen from "../screens/farmer/CheckoutScreen";
import AddFarm from "../screens/farmer/farm/AddFarm";
import ManageFarm from "../screens/farmer/farm/ManageFarm";
import EditFarm from "../screens/farmer/farm/EditFarm";
import Profile from "../screens/farmer/profile/Profile";
import ChangePassword from "../screens/farmer/profile/ChangePassword";
import AddBank from '../screens/farmer/wallet/AddBank';
import Success from '../screens/farmer/equipment_service/Success';
import PayBalance from '../screens/farmer/farm/PayBalance';
import Page_not_found from "../screens/404_page/404";


const FarmerRoutes = () => {
    return (
        <Switch>
            <Redirect from="/login" to="/farmer"/>
            <Redirect from="/register" to="/farmer"/>
            <Redirect exact from="/" to="/farmer"/>


            <Route path='/farmer' component={FarmerScreen} exact/>
            <Route path='/farmer/farm/equipment' component={EquipmentServiceScreen} exact/>
            <Route path='/farmer/farm/equipment/view' component={ManageEquipment} exact/>
            <Route path='/farmer/wallet/settings' component={WalletSettingsScreen} exact/>
            <Route path='/farmer/wallet/bank' component={AddBank} exact/>
            <Route path='/farmer/wallet' component={WalletScreen} exact/>
            <Route path='/farmer/farm/equipment/service/:id' component={EquipmentScreen} exact/>
            <Route path='/farmer/checkout/:id' component={CheckoutScreen} exact/>
            <Route path='/farmer/success' component={Success} exact/>
            <Route path='/farmer/pay/balance/:id' component={PayBalance} exact/>
            <Route path='/farmer/farm/add' component={AddFarm} exact/>
            <Route path='/farmer/farm/manage' component={ManageFarm} exact/>
            <Route path='/farmer/farm/manage/edit/:farm_id' component={EditFarm} exact/>
            <Route path='/farmer/profile' component={Profile} exact/>
            <Route path='/farmer/change_password' component={ChangePassword} exact/>
            <Route component={Page_not_found}/>

        </Switch>
    )
}

export default FarmerRoutes